'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Listbox": "Polaris-Listbox"
};

exports.default = styles;
